import React from 'react';
import Navbar from './Navbar';
import './App.css';

function Privacy() {
  return (
    <div className="App info-page">
      <Navbar />
      <div className="info-content">
        <div className="info-container">
          <h1>Privacy Policy for album.cards</h1>

          <p><strong>Last Updated:</strong> September 21, 2025</p>

          <h2>Introduction</h2>
          <p>
            album.cards ("we," "our," or "us") respects your privacy. This Privacy Policy explains how we handle information when you use the album.cards mobile application (the "App").
          </p>

          <h2>Information We Collect</h2>
          <p>We do not collect, store, or retain any personal information about our users.</p>

          <h2>Temporary Technical Data</h2>
          <p>When you stream music through our App:</p>
          <ul>
            <li>Our servers may temporarily generate access tokens to facilitate music streaming</li>
            <li>Standard server logs may be created during connection but are automatically deleted</li>
            <li>No personal identifiers, user accounts, or persistent tracking occurs</li>
          </ul>

          <h2>Local Device Storage</h2>
          <ul>
            <li>The App may temporarily cache music files on your device to improve performance</li>
            <li>This cached data is stored locally on your device and is not transmitted to us</li>
            <li>Cached files may be automatically cleared by your device's operating system</li>
          </ul>

          <h2>Device Permissions</h2>
          <p>The App requests access to:</p>
          <ul>
            <li><strong>NFC (Near Field Communication)</strong>: Required to scan album cards and access music content</li>
          </ul>

          <h2>Third-Party Services</h2>
          <p>We do not use any third-party analytics, advertising networks, or tracking services.</p>

          <h2>Data Sharing</h2>
          <p>We do not sell, trade, or share any user information with third parties.</p>

          <h2>Children's Privacy</h2>
          <p>Our App does not knowingly collect information from children under 13.</p>

          <h2>Changes to This Policy</h2>
          <p>We may update this Privacy Policy occasionally. Changes will be posted with a new "Last Updated" date.</p>

          <h2>Contact Us</h2>
          <p>If you have questions about this Privacy Policy, please contact us at quintonsung@gmail.com.</p>
        </div>
      </div>
    </div>
  );
}

export default Privacy;